
export const TOPIC_BIOTRUST_OFFER_ID = 'bt-offer';
export const TOPIC_EXPERIMENT_ID = 'experiment';
export const TOPIC_GTAG_EVENT = 'gtag.event';
export const TOPIC_TATARI_SESSION_ID = 'tatari-session-id';
/** Topic receiving messages to trigger the start of an experiment. */
export const TOPIC_EXPERIMENT_BEGIN = 'experiment.begin';
export const TOPIC_IP_DATA = 'ip-data';
export const TOPIC_SPLIT_TEST_LOADED = 'split-test-loaded';
